import React, { useEffect, useState } from "react";
import WeeklyRevenue from "./WeeklyRevenue";
const Step = ({ number, title, active, changeActive, completed }) => {
  const [bg, setBg] = useState("");
  useEffect(() => {
    if (active) setBg("bg-[#00A465] text-[#fff]");
    else setBg("");
  }, [active]);

  return (
    <button
      className="flex items-center gap-3 border-b w-full py-4 cursor-pointer group"
      onClick={() => changeActive(number)}
    >
      <div
        className={`flex items-center justify-center rounded-full border-2 border-green-500 text-2xl h-12 w-12 group-hover:bg-green-500 group-hover:text-white ${
          active && completed && "bg-green-500 text-white"
        } ${
          active &&
          !completed &&
          "bg-yellow-500 text-white border-yellow-600 group-hover:bg-yellow-500"
        }`}
      >
        {number}
      </div>
      <h4 className="text-xl">{title}</h4>
    </button>
  );
};

export default Step;
